import { handleActions } from 'redux-actions';
import { Actions } from '../constants';

export const initialState = null;

const reducer = handleActions(
  {
    [Actions.SET_USER_IDENTIFIER]: (_, { payload }) => payload || initialState,
  },
  initialState,
);

export default reducer;
